module.exports = __webpack_public_path__ + "f4103669740e1258103e7fee7bfafbc1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-SemiBold.woff
// module id = 1805
// module chunks = 1